<template>
  <div class="question-overlay">
    <!-- Soru ve Şıkları modalı -->
    <div v-if="!showResult" class="question-container question-mode">
      <div class="question-header">
        <div class="question-icon">
          <i class="icon-feather-help-circle"></i>
        </div>
        <h3>{{ question.text }}</h3>
      </div>

      <div class="question-content">
        <div class="options-container">
          <div v-for="option in question.options" :key="option.id"
               :class="['option-item', { 'selected': selectedOption?.id === option.id }]"
               @click="selectOption(option)">
            <div class="option-text">{{ option.text }}</div>
          </div>
        </div>

        <div class="question-actions">
          <button :disabled="!selectedOption" class="submit-btn" @click="submitAnswer">
            {{ $t('general.submit_answer') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Cevaplandıktan Sonra (İkinci Modal) -->
    <div v-if="showResult" class="question-container feedback-mode">
      <div class="feedback-content">
        <div class="feedback-header">
          <div class="feedback-icon">
            <i :class="isCorrect ? 'icon-feather-check-circle' : 'icon-feather-x-circle'"></i>
          </div>
          <h3>{{ question.text }}</h3>
        </div>

        <!-- Seçilen cevap -->
        <div class="selected-answer">
          <h4>{{ $t('general.your_answer') }}:</h4>
          <div :class="['selected-option', isCorrect ? 'correct' : 'incorrect']">
            <div class="option-text">{{ selectedOption?.text }}</div>
            <div class="answer-status">
              <i :class="isCorrect ? 'icon-feather-check' : 'icon-feather-x'"></i>
              <span>{{ isCorrect ? $t('general.correct') : $t('general.wrong') }}</span>
            </div>
          </div>
        </div>

        <!-- Doğru cevap gösterimi (yanlış cevap verildiyse) -->
<!--        <div v-if="!isCorrect" class="correct-answer">-->
<!--          <h4>{{ $t('general.correct_answer') }}:</h4>-->
<!--          <div class="correct-option">-->
<!--            <div class="option-text">-->
<!--              {{ question.options.find(opt => opt.is_correct === 1)?.text }}-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <div v-if="getFeedbackMessage" :class="['feedback-message', isCorrect ? 'correct' : 'incorrect']">
          <div class="feedback-content-wrapper">
            <div class="feedback-icon-wrapper">
              <i class="icon-feather-message-circle"></i>
            </div>
            <div class="feedback-text">
              <p>{{ getFeedbackMessage }}</p>
            </div>
          </div>
        </div>

        <!-- Yanlış cevap durumunda back time bilgisi -->
        <div v-if="!isCorrect && apiResult?.back_time" class="back-time-info">
          <i class="icon-feather-rewind"></i>
          <span>Seni videonun {{ apiResult.back_time }} saniyesine yönlendiriyoruz.</span>
        </div>

        <div class="feedback-actions">
          <button class="continue-btn" @click="continueVideo">
            {{ $t('general.continue') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionFeedbackOverlay',
  props: {
    question: {
      type: Object,
      required: true
    },
    apiResult: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      selectedOption: null,
      showResult: false,
    };
  },
  computed: {
    isCorrect() {
      // API sonucu is_correct alanını içermiyorsa seçilen şıkkı fallback olarak kullan.
      if (this.apiResult?.is_correct !== undefined && this.apiResult?.is_correct !== null) {
        return this.isCorrectFlag(this.apiResult.is_correct);
      }
      return this.isCorrectFlag(this.selectedOption?.is_correct);
    },
    getFeedbackMessage() {
      if (!this.apiResult) return null;

      if (this.isCorrect) {
        // Doğru cevap: API'den gelen correct_feedback varsa onu göster
        return this.apiResult.correct_feedback || null;
      } else {
        // Yanlış cevap: API'den gelen incorrect_feedback varsa onu göster
        return this.apiResult.incorrect_feedback || null;
      }
    }
  },
  mounted() {
    // Soru gösterildiğinde video'yu duraklat
    this.$emit('pause-video');
  },
  watch: {
    apiResult: {
      handler(newResult) {
        if (newResult) {
          this.showResult = true;
        }
      },
      immediate: true
    }
  },
  methods: {
    isCorrectFlag(value) {
      return value === true || value === 1 || value === '1' || value === 'true';
    },

    selectOption(option) {
      if (this.showResult) return; // Sonuç gösteriliyorsa seçim yapılamaz
      this.selectedOption = option;
    },

    submitAnswer() {
      if (!this.selectedOption) return;

      // API'ye cevap gönder ve sonucu bekle
      this.$emit('answer-the-selected-question', this.question.id, this.selectedOption.id);
    },

    continueVideo() {
      this.$emit('continue-video', this.question.id, this.selectedOption?.id);
    },
  }
};
</script>

<style scoped src="./question-feedback-overlay.css"></style>
